import ApiUtils from '@/utils/api/ApiUtils'
import ObjArrUtils from '@/utils/ObjArrUtils'
import { Base, BREAD, error } from '@/store/base/module'

// const PageConst = {

// }

const module = {
  state: {
    teacherSchedule: [],
    currentScreen: 1,
    selectedDate: null,
    C11201_getTeacherScheduleStatus: [],
    C11201_getOpenScheduleDate: [],
  },

  getters: {

  },
  mutations: {
    setCurrentScreen(state, payload) {
      state.currentScreen = payload
    }
  },
  actions: {
    async C11201_getTeacherSchedule({ state, commit }, payload) {
      return await ApiUtils.postData({
        data: {
          C11201_getTeacherSchedule:{
            api: 'T0050CalendarService.C11201_getTeacherSchedule',
            input: payload
          },
          C11201_getTeacherScheduleStatus: {
            api: 'T0050CalendarService.C11201_getTeacherScheduleStatus',
            input: payload
          },
          C11201_getOpenScheduleDate: {
            api: 'T3014ScheduleDeliveryService.C11201_getOpenScheduleDate',
            input: payload
          }
        }
      }).then((data) => {
        commit('setState', {
          teacherSchedule: data.C11201_getTeacherSchedule.output,
          C11201_getTeacherScheduleStatus: data.C11201_getTeacherScheduleStatus.output,
          C11201_getOpenScheduleDate: data.C11201_getOpenScheduleDate.output,
        })
      })
    },
  }
}

export default ObjArrUtils.merge(Base, error, BREAD, module)
